import React, { useEffect, useState } from "react";
import deleteIcon from "../../assets/images/icons/delete.png";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmModal from "../dialog/ConfirmationDialog";
import ConfirmationDialog from "../dialog/ConfirmationDialog";
import { getDomainInfo } from "../../utils/utils";
import { toast } from 'react-toastify'; 
import { FaMinus, FaPlus, FaTrash } from "react-icons/fa";

let TOAST_ID = "no-inventory-toast";

function SingleCartProductNew({
  id,
  src,
  productName,
  variantname,
  value,
  price,
  mrp,
  delcartitem,
  onQuantityChange,
  newquantity,
  itemIndex,
  stock  
}) {
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();
  const { userId } = useParams();
  const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);
  const [showConfirm, setShowConfirm] = useState(false);

  // console.log(stock, "stock");
  


  useEffect(() => {
    setQuantity(newquantity);
  }, [newquantity]);

  const handleIncrement = () => {
    if (quantity >= stock) return;
    const newQty = quantity + 1;
    setQuantity(newQty);
    onQuantityChange(itemIndex, newQty);
  };

  const isIncrementDisabled = quantity >= stock;

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity((prevQ) => prevQ - 1);
      onQuantityChange(itemIndex, quantity - 1);
    }
  };

  // Helper function to remove commas and convert price to a number
  const getCleanedPrice = () => {
    return Number(price);
  };

  // Format the calculated price to show commas in large numbers
  const calculateTotalPrice = () => {
    return (getCleanedPrice() * quantity).toLocaleString();
  };

  const calculateTotalMrp = () => {
    return (Number(mrp) * quantity).toLocaleString();
  };

  const handelimgClick = () => {
    navigate(
      isPredefinedDomain
        ? `/${uid}/productdetails/${productName.replace(/\s+/g, "_")}`
        : `/productdetails/${productName.replace(/\s+/g, "_")}`, {state : {productId:id}}
    );
  };

  const handleCartItemDeletion = () => {
    delcartitem(itemIndex);
    setShowConfirm(false);
  };

  const isS3Url = src?.includes("https://hello-image-bucket.s3");
  
  const defaultImageUrl = process.env.REACT_APP_S3_URL || "default_url_if_missing";

  const imageUrl = isS3Url ? src : defaultImageUrl + src;

  return (
    <>
      {/* <div className="order-item">
        <img
            width={84}
            height={93}
            src={imageUrl || "https://via.placeholder.com/84x93"}
            alt={productName}
            onClick={handelimgClick}
            style={{ cursor: "pointer" }}
        />
        <div className="item-details">
          <ConfirmationDialog
              show={showConfirm}
              onClose={() => setShowConfirm(false)}
              onConfirm={handleCartItemDeletion}
              confirmationMessage="Do you want to remove this item from cart?"
          />
          <h3>{productName}</h3>
          <p className="item-size-color">
            {variantname}: <span className="item-color">{value}</span>
          </p>
          <div className="quantity-control">
            <button onClick={() => handleDecrement()}>
              <i
                  className="fa-solid fa-minus minus-circle-icon circle-icon"
              ></i>
            </button>
            <span>{quantity}</span>
            <button
              onClick={() => {
                if (isIncrementDisabled) {
                  if (!toast.isActive(TOAST_ID)) {
                  toast.warn("No more inventory", {toastId: TOAST_ID, position: "top-center", autoClose: 2000 });
                  // return;
                }else{
                  toast.update(TOAST_ID, {
          render: "No more inventory",
          autoClose: 2000,
        });
      }
      return;
                }
                handleIncrement();
              }}
              style={{
                opacity: isIncrementDisabled ? 0.5 : 1,
                cursor: isIncrementDisabled ? "not-allowed" : "pointer"
              }}
            >
              <i className="fa-solid fa-plus plus-circle-icon circle-icon"></i>
            </button>
          </div>
        </div>
        <div className="price-info">
          <div className="current-price">₹ {calculateTotalPrice()}</div>
          <div className="original-price">{mrp && "₹" + calculateTotalMrp()}</div>
          <button onClick={() => setShowConfirm(true)}>Remove</button>
        </div>
      </div> */}
  <div className="flex">
                                <figure><img src={imageUrl || "https://via.placeholder.com/84x93"} alt={productName} onClick={handelimgClick} /></figure>
                                <div className="content">
                                  <ConfirmationDialog
              show={showConfirm}
              onClose={() => setShowConfirm(false)}
              onConfirm={handleCartItemDeletion}
              confirmationMessage="Do you want to remove this item from cart?"
          />
                                    <h5 className="h5 cart-title">{productName}</h5>
                                   {value? <p className="varient-text">{variantname} <b>{value}</b></p>:null}
                                    {/* <h6 className="h6 cart-price">₹{calculateTotalPrice()} <del>{mrp && "₹" + calculateTotalMrp()}</del></h6> */}
          {price === 0 ? (
            <h6 className="h6 cart-price">₹ {calculateTotalMrp()}</h6>
          ) : (
            <>
              <h6 className="h6 cart-price">₹ {calculateTotalPrice()}
              {mrp > price && <del>₹ {calculateTotalMrp()}</del>}</h6>
            </>
          )}
                                    <div className="inner-flex">
                                        <div className="incremnet-dicrement-box">
                                            <div className="icon-box box-decrease"  onClick={() => handleDecrement()}><FaMinus /></div>
                                            <div className="text-box">{quantity}</div>
                                            <div className="icon-box box-increase" onClick={() => {
                if (isIncrementDisabled) {
                  if (!toast.isActive(TOAST_ID)) {
                  toast.warn("No more inventory", {toastId: TOAST_ID, position: "top-center", autoClose: 2000 });
                  // return;
                }else{
                  toast.update(TOAST_ID, {
          render: "No more inventory",
          autoClose: 2000,
        });
      }
      return;
                }
                handleIncrement();
              }} 
              style={{
                opacity: isIncrementDisabled ? 0.5 : 1,
                cursor: isIncrementDisabled ? "not-allowed" : "pointer"
              }}><FaPlus /></div>
                                        </div>
                                        <div className="delete-box" onClick={() => setShowConfirm(true)}>
                                            <FaTrash /> <span>Remove</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </>
  
  );
}

export default SingleCartProductNew;
